var functions = {
  isGroupMember (component, groupname) {
    if (component.$auth.check()) {
      console.log(component.$auth.watch.data['cognito:groups'])
      for (let i = 0; i < component.$auth.watch.data['cognito:groups'].length; i++) {
        if (component.$auth.watch.data['cognito:groups'][i] === groupname) {
          return true
        }
      }
      return false
    } else {
      return false
    }
  },
  jsonpretty (data) {
    return JSON.stringify(data, null, 2)
  }
}

module.exports = functions



// WEBPACK FOOTER //
// ./client/views/homenet/lib/utils.js